import { TipoElementoOperacionEnergiaEnum, TipoSuministroTramiteEnergiaEnum, type CreateRappelEnergiaModel, type DetailRappelEnergiaModel } from '@api/api';
import { toUTCDateOnly } from '@helpers/date-parser-helper';

export class CreateRappelEnergia implements CreateRappelEnergiaModel {

  IdEmpresaServicios: string = '';
  TipoElemento: TipoElementoOperacionEnergiaEnum = TipoElementoOperacionEnergiaEnum.Oferta;
  TipoSuministro: TipoSuministroTramiteEnergiaEnum = TipoSuministroTramiteEnergiaEnum.Luz;
  FechaInicio: Date = new Date();
  FechaFin: Date = new Date();
  VolumenMin: number = 0;
  Importe: number = 0;
  PotenciaMax: number | null = 0;
  IdEmpresaAgentes: string | null = null;
  Nombre: string | null = null;
  
  EmpresaServicios: string = '';

  constructor(data?: Partial<CreateRappelEnergia>) {
    Object.assign(this, data);

    if (data?.FechaFin == null)
    {
      var today = new Date();
      this.FechaInicio = new Date(today.getFullYear(), today.getMonth(), 1, 10);
      this.FechaFin = new Date(today.getFullYear(), today.getMonth() + 1, 0, 10);
    }

    this.FechaInicio = toUTCDateOnly(this.FechaInicio);
    this.FechaFin = toUTCDateOnly(this.FechaFin);
  }

  public createFromRappelDetail(rappel: DetailRappelEnergiaModel): CreateRappelEnergia{
    Object.assign(this, rappel);
    return this;
  }

}